exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list__tile{padding:8px 16px;height:100%}.v-chip .v-chip__content{cursor:pointer}", ""]);

// exports
